import React from 'react';
import * as settings from 'Settings';

import styles from './GameQuestion.scss';
import QuestionIcon from './head-outline.svg';

const GameQuestion = ({ text, theme, appSlug }) => {
  return (
    <li
      className={`GameQuestion GameQuestion--${theme} GameQuestion--${appSlug}`}
    >
      {theme === 'section' ? (
        <QuestionIcon className="GameQuestion__graphic" />
      ) : null}
      <span className="GameQuestion__text">{text}</span>
    </li>
  );
};

export default GameQuestion;
